import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ApiService } from './api.service';
import {
  ICreateOrUpdateStudentAssignmentDTO,
  IStudentAssignmentDTO,
  IStudentAssignmentRequest,
} from '@app/infrastructure/models/student-assignment';
import { environment } from '@env/environment';
import { NotificationService } from '../notification.service';
import { AssignmentStatusEnum } from '@app/infrastructure/models/classroom-assignment';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class StudentAssignmentService {
  // TODO: Change route when the API is updated
  private controllerRoute: string = 'students';
  private url: string = `${environment.apiRoute}`;

  constructor(
    private apiService: ApiService,
    private notificationService: NotificationService,
  ) {
    this.url = `${environment.apiRoute}/${this.controllerRoute}`;
  }

  public getStudentAssignmentList(
    studentId: string,
    status?: AssignmentStatusEnum,
  ): Observable<IStudentAssignmentDTO[]> {
    const endpoint = `${this.url}/${studentId}/assignments`;
    const assignmentStatus = 'assignmentStatus';

    if (!status) status = AssignmentStatusEnum.ASSIGNED;
    let params = new HttpParams();
    params = params.append(assignmentStatus, status);

    return this.apiService.get<IStudentAssignmentDTO[]>(endpoint, {
      params,
    });
  }

  public findStudentAssignment(
    studentId: string,
    id: number,
  ): Observable<IStudentAssignmentDTO> {
    const endpoint = `${this.url}/${studentId}/assignments/${id}`;

    return this.apiService.get<IStudentAssignmentDTO>(endpoint);
  }

  public createStudentAssignment(
    studentId: string,
    payload: IStudentAssignmentRequest,
  ): Observable<IStudentAssignmentDTO> {
    const endpoint = `${this.url}/${studentId}/assignments`;

    return this.apiService
      .post<IStudentAssignmentDTO, IStudentAssignmentRequest>(endpoint, payload)
      .pipe(
        tap(() => {
          const message = `Assignment started.`;
          return this.notificationService.showSuccess([message]);
        }),
      );
  }

  public updateStudentAssignment(
    payload: IStudentAssignmentRequest,
    studentId: string,
    id: number,
  ): Observable<IStudentAssignmentDTO> {
    const endpoint = `${this.url}/${studentId}/assignments/${id}`;
    return this.apiService
      .patch<IStudentAssignmentDTO, IStudentAssignmentRequest>(
        endpoint,
        payload,
      )
      .pipe(
        tap(() => {
          const message = `Assignment updated.`;
          return this.notificationService.showSuccess([message]);
        }),
      );
  }
}
